const doc = [({"da":({"js":({"admin":({"communication":({"bottom_bar":({"ready_to_send":"Klar til afsendelse"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;